"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowHasHTMLDialogElement = windowHasHTMLDialogElement;
exports.hasShowModal = hasShowModal;
exports.showModal = showModal;
function windowHasHTMLDialogElement() {
    return window.HTMLDialogElement !== undefined;
}
function hasShowModal(dialogElement) {
    const de = dialogElement;
    return de.showModal !== undefined && typeof (de.showModal) === 'function';
}
function showModal(dialogElement) {
    dialogElement.showModal?.();
}
